import { IModel } from "makerjs";
import { makerjs } from "../../../../source/js/shared/rendering/makerjs";
import { InterfaceModelDecorator } from "./PreviewModelDecorator";
import Cutout from "@/Models/Cutout";
import {getShapeModelCenter} from "@/functions/makerjs";

export default class CutoutMoveDecorator implements InterfaceModelDecorator {
	constructor(
		private parentDecorator: InterfaceModelDecorator | null,
		private cutout: Cutout,
		private baseShapeModel: IModel
	) {}

	getModel(): IModel {
		let model = { models: {} } as IModel;

		if (this.parentDecorator) {
			model = this.parentDecorator.getModel();
		}

		if ( typeof model.models.shapeModel === 'undefined' ) {
			return model;
		}

		const measure = makerjs.measure.modelExtents(model);
		const baseShapeMeasure = makerjs.measure.modelExtents(this.baseShapeModel.models.shapeModel.models.baseModel);

		const center = getShapeModelCenter(model.models.shapeModel.models.baseModel);

		// Add exception for text as these can have low values that are less than zero.
		if ( ( measure['low'][0] === 0 && measure['low'][1] === 0 ) || ( this.cutout.shape === 'text' ) ) {
			const centerX = center[0];
			const centerY = center[1];

			makerjs.model.move(model, [-centerX, -centerY]);
		}

		const offsets = this.cutout.offsets;

		makerjs.model.moveRelative(model, [offsets[0].in_mm(), offsets[1].in_mm()]);
		makerjs.model.moveRelative(model, [baseShapeMeasure['low'][0], baseShapeMeasure['low'][1]]);

		// Push the cutout a little bit outside edge of the base shape, for every corner.
		// This fixes this know issue in makerjs, see https://github.com/microsoft/maker.js/issues/377
		const cutoutMeasure = makerjs.measure.modelExtents(model);
		if(cutoutMeasure['low'][0] === baseShapeMeasure['low'][0]) {
			makerjs.model.moveRelative(model, [-0.1, 0]);
		}

		if(cutoutMeasure['low'][1] === baseShapeMeasure['low'][1]) {
			makerjs.model.moveRelative(model, [0, -0.1]);
		}

		if(cutoutMeasure['high'][0] === baseShapeMeasure['high'][0]) {
			makerjs.model.moveRelative(model, [0.1, 0]);
		}

		if(cutoutMeasure['high'][1] === baseShapeMeasure['high'][1]) {
			makerjs.model.moveRelative(model, [0, 0.1]);
		}

		return model;
	}
}
